export default __webpack_public_path__ + "static/media/faktory_branco.416c9388.svg";